import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";

import ApiService from "../../../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

const StudentapproveView = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const membershipId = location.state?.membershipId;

  const [student, setStudent] = useState(null);

  const [loading, setLoading] = useState(true);

  /* =========================================
     FETCH STUDENT DETAILS
  ========================================= */
  useEffect(() => {

    if (membershipId) {

      fetchStudent();

    } else {

      setLoading(false);
    }

  }, [membershipId]);

  const fetchStudent = async () => {

    try {

      const res = await AdminAPI.getMemberById(membershipId);

      console.log("FULL API RESPONSE:", res);

      console.log("API DATA:", res.data);

      /* FULL RESPONSE */
      const data = res.data || {};

      console.log("STUDENT DATA:", data);

      setStudent(data);

    } catch (err) {

      console.error("API ERROR:", err);

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     NO MEMBERSHIP ID
  ========================================= */
  if (!membershipId) {

    return (
      <div className="container mt-5 text-center">

        <h4>No Membership ID found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  /* =========================================
     LOADING
  ========================================= */
  if (loading) {

    return (
      <div className="container mt-5 text-center">

        <h5>Loading...</h5>

      </div>
    );
  }

  /* =========================================
     NO DATA
  ========================================= */
  if (!student) {

    return (
      <div className="container mt-5 text-center">

        <h4>No student found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  /* =========================================
     MEMBER + DETAILS
  ========================================= */
  const member = student.member || {};

  const details = student.details || {};

  return (

    <div className="container student-profile-container mt-5 mb-0">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">

        <h4 className="fw-bold mt-3">
          STUDENT DETAILS
        </h4>

      </div>

      {/* BACK BUTTON */}
      <button
        className="jobback mb-3"
        onClick={() => navigate(-1)}
      >
        <TiArrowBack /> Back
      </button>

      {/* =========================================
          PERSONAL DETAILS
      ========================================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Personal Details
        </h5>

        <div className="row g-3 mt-2">

          {/* PROFILE */}
          <div className="col-md-4">

            <label className="empv-label">
              Profile Photo
            </label>

            <img
              src={
                member.profile_pic ||
                "https://dummyimage.com/150x150/ccc/000&text=No+Image"
              }
              className="img-fluid profile-pic"
              alt="profile"
            />
          </div>

          {/* FULL NAME */}
          <div className="col-md-4">

            <label className="empv-label">
              Full Name
            </label>

            <input
              className="form-control"
              value={member.full_name || ""}
              readOnly
            />
          </div>

          {/* EMAIL */}
          <div className="col-md-4">

            <label className="empv-label">
              Email
            </label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />
          </div>

          {/* MOBILE */}
          <div className="col-md-4">

            <label className="empv-label">
              Mobile
            </label>

            <input
              className="form-control"
              value={member.mobile || ""}
              readOnly
            />
          </div>

          {/* GENDER */}
          <div className="col-md-4">

            <label className="empv-label">
              Gender
            </label>

            <input
              className="form-control"
              value={member.gender || ""}
              readOnly
            />
          </div>

          {/* DOB */}
          <div className="col-md-4">

            <label className="empv-label">
              DOB
            </label>

            <input
              className="form-control"
              value={member.dob || ""}
              readOnly
            />
          </div>

          {/* BLOOD GROUP */}
          <div className="col-md-4">

            <label className="empv-label">
              Blood Group
            </label>

            <input
              className="form-control"
              value={member.blood_group || ""}
              readOnly
            />
          </div>

          {/* STATE */}
          <div className="col-md-4">

            <label className="empv-label">
              State
            </label>

            <input
              className="form-control"
              value={member.state || ""}
              readOnly
            />
          </div>

          {/* DISTRICT */}
          <div className="col-md-4">

            <label className="empv-label">
              District
            </label>

            <input
              className="form-control"
              value={member.district || ""}
              readOnly
            />
          </div>

          {/* PINCODE */}
          <div className="col-md-4">

            <label className="empv-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={member.pincode || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* =========================================
          STUDENT DETAILS
      ========================================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Student Details
        </h5>

        <div className="row g-3 mt-2">

          {/* MEMBERSHIP ID */}
          <div className="col-md-4">

            <label className="empv-label">
              Membership ID
            </label>

            <input
              className="form-control"
              value={member.membership_id || ""}
              readOnly
            />
          </div>

          {/* ROLE */}
          <div className="col-md-4">

            <label className="empv-label">
              Role
            </label>

            <input
              className="form-control"
              value={member.role || ""}
              readOnly
            />
          </div>

          {/* STATUS */}
          <div className="col-md-4">

            <label className="empv-label">
              Status
            </label>

            <input
              className="form-control"
              value={member.status || ""}
              readOnly
            />
          </div>

          {/* CANDIDATE TYPE */}
          <div className="col-md-4">

            <label className="empv-label">
              Candidate Type
            </label>

            <input
              className="form-control"
              value={member.candidate_type || ""}
              readOnly
            />
          </div>

          {/* WHATSAPP */}
          <div className="col-md-4">

            <label className="empv-label">
              WhatsApp
            </label>

            <input
              className="form-control"
              value={String(member.whatsapp_notification)}
              readOnly
            />
          </div>

          {/* CREATED */}
          <div className="col-md-4">

            <label className="empv-label">
              Created At
            </label>

            <input
              className="form-control"
              value={member.created_at || ""}
              readOnly
            />
          </div>

          {/* APPROVED */}
          <div className="col-md-4">

            <label className="empv-label">
              Approved At
            </label>

            <input
              className="form-control"
              value={member.approved_at || ""}
              readOnly
            />
          </div>

          {/* REJECTED */}
          <div className="col-md-4">

            <label className="empv-label">
              Rejected At
            </label>

            <input
              className="form-control"
              value={member.rejected_at || ""}
              readOnly
            />
          </div>

          {/* UNIVERSITY */}
          <div className="col-md-4">

            <label className="empv-label">
              University Name
            </label>

            <input
              className="form-control"
              value={details.university_name || ""}
              readOnly
            />
          </div>

          {/* COLLEGE */}
          <div className="col-md-4">

            <label className="empv-label">
              College Name
            </label>

            <input
              className="form-control"
              value={details.college_name || ""}
              readOnly
            />
          </div>

          {/* COLLEGE CODE */}
          <div className="col-md-4">

            <label className="empv-label">
              College Code
            </label>

            <input
              className="form-control"
              value={details.college_code || ""}
              readOnly
            />
          </div>

          {/* QUALIFICATION */}
          <div className="col-md-4">

            <label className="empv-label">
              Qualification
            </label>

            <input
              className="form-control"
              value={details.qualification || ""}
              readOnly
            />
          </div>

          {/* DEPARTMENT */}
          <div className="col-md-4">

            <label className="empv-label">
              Department
            </label>

            <input
              className="form-control"
              value={details.department || ""}
              readOnly
            />
          </div>

          {/* START YEAR */}
          <div className="col-md-4">

            <label className="empv-label">
              Start Year
            </label>

            <input
              className="form-control"
              value={details.start_year || ""}
              readOnly
            />
          </div>

          {/* END YEAR */}
          <div className="col-md-4">

            <label className="empv-label">
              End Year
            </label>

            <input
              className="form-control"
              value={details.end_year || ""}
              readOnly
            />
          </div>

          {/* LOCATION */}
          <div className="col-md-4">

            <label className="empv-label">
              Location
            </label>

            <input
              className="form-control"
              value={details.location || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* DEBUG */}
      <div className="card p-3">

        <h6>DEBUG API RESPONSE</h6>

        <pre style={{ fontSize: "12px" }}>
          {JSON.stringify(student, null, 2)}
        </pre>

      </div>

    </div>
  );
};

export default StudentapproveView;